<template>

<div class='row'>

    <loading-div v-if='!isReady'></loading-div>

    <div class="col-12">
        <h4>Тръжни процедури</h4>
    </div>

    <div class='col-12' v-if='canStart && isReady'>
        <button class='btn btn-info'>
            Започни нова процедура
        </button>

        <div class='alert alert-info'>
            Като ръководител на проекта, вие можете да стартирате тръжни процерури.
        </div>

        <div class="row">
            <div class="col-12 form-group">
                <label for='rid'>Моля изберете тръжна процедура</label>
                <select id='rid' class='form-control' type="text" v-model='newPhase.rid'>
                    <option v-for='p in phList' :value='p.id'>{{ p.name }}</option>
                </select>
            </div>
            <div class="col-12 form-group">
                <label for='days'>Продължителност на търга ( брой дни )</label>
                <input id='days' class='form-control' type="text" v-model.number='newPhase.days'>
            </div>
            <div class="col-12 form-group">
                <label for='info'>Кратко описание</label>
                <textarea id='info' class='form-control' v-model.trim='newPhase.info'></textarea>
            </div>

            <div @click='startPhase' class='col-12'>
                <form-validator ref='validator' :fields='validatorFields'></form-validator>
                <button class='btn btn-info'>
                    Стартирай тръжната процедура
                </button>
            </div>
        </div>

    </div>

    <div v-if='page == "list"'>
        <h4>Стартирани процедури : </h4>

        <div v-for='sp in subPhases' class='col-12'>
            Процедура за : {{ sp.name }}, начало : {{ sp.start_date }}, край : {{ sp.end_date }} 
            <button @click='setPhase( sp )' class='btn btn-info'>Преглед</button>
        </div>

        <div v-if='isReady && !subPhases.length' class='alert alert-info col-12'>
            До момента няма стартирани тръжни процедури
        </div>
    </div>

    <div v-if='page == "single"'  class='col-12 mt-3'>

        <button @click='page = "list"' class='btn btn-info mb-2'>Назад</button>

        <div v-if='canStart' class='col-12'>
            
            <in-progress v-if='projectPhase.status == 0'></in-progress>
            <phase-ended v-if='projectPhase.status == 1' :pp='projectPhase'></phase-ended>

        </div>

        <div v-if='!canStart' class='col-12'>

            <worker-form v-if='projectPhase.status == 0'></worker-form>
            <worker-ended v-if='projectPhase.status == 1' :pp='projectPhase'></worker-ended>

        </div>
    </div>

</div>

</template>

<script>
    export default {

        mounted() {
            
            this.getData();

        },

        created() {
                
            this.isOwner = this.user.id == this.$parent.project.user_id;
            this.newPhase = Object.assign({}, this.mdl);

        },

        data() {
            return {

                isReady : false,
                isOwner : false,
                canStart : false,

                page : "list",

                //Array with phase sub-phases
                subPhases : [],
                projectPhase : false,
                phase : this.$parent.phase,
                project : this.$parent.project,

                newPhase : false,

                mdl : {
                    
                    rid : null,
                    info  : '',
                    days  : 7,
                    pp : this.$parent.projectPhase.id

                },

                phList : [],

                validatorFields : [
                    { 
                        selector  : "#rid",
                        required : true,
                        customErr : 'Моля изберете тръжна процедура'
                    },
                    { 
                        selector  : "#days",
                        min       : 1,
                        customErr : 'Моля въведете брой дни'
                    }
                ]

            }
        },

        methods : {

            getData() { 

                var me = this;

                me.ajax.call('phs:gchp', { pp : this.$parent.projectPhase.id }, (r) => {

                    if( r.status == 'success' ) {
                        
                        me.subPhases = r.data.sp;
                        me.phList    = r.data.pl;
                        me.canStart  = r.data.cs;

                    }

                    me.isReady = true;

                })

            },

            setPhase( sp ) {

                this.projectPhase = sp;
                this.page = 'single';

            },
 
            startPhase() { 

                var me = this;

                this.$refs.validator.validate({
                    resolve(){

                        me.ajax.call('phs:stchp', me.newPhase, (r) => {

                            if( r.status == 'success' ) {
                                
                                me.subPhases.push( r.data );
                                me.newPhase = Object.assign({}, me.mdl);

                                $.notify("Тръжната процедура беше стартирана успешно","success");

                            }

                        })
                    }
                });

            }

        },

        components : {
            'worker-form'   : require('./Worker/Form.vue').default,
            'worker-ended'  : require('./Worker/Ended.vue').default,
            'in-progress'   : require('./Owner/InProgress.vue').default,
            'phase-skipped' : require('./Skipped.vue').default,
            'phase-ended'   : require('./Owner/Ended.vue').default,
            'multi-phase'   : require('./MultiPhase.vue').default,
        }

    }
</script>
